module.exports = __webpack_public_path__ + "static/media/zoom-out-icon.60091b24.svg";